import { HomeIcon } from 'assets/svg/sidebarIcons';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
  id: 'dashboard',
  title: '',
  type: 'group',
  children: [
    {
      id: 'default',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: HomeIcon,
      allowedRoles: ['admin', 'superAdmin', 'marketingSpecialist'],
      breadcrumbs: false
    }
  ]
};

export default dashboard;
